export function tableWrap() {
    $('table').each(function () {
        $(this).wrap('<div class="table-wrap"></div>');
    })
}


// WEBPACK FOOTER //
// ./assets/js/modules/tableWrap.js